<template>
  <div class="sub-container" v-show="!loading">
    <div class="top-ctrl">
      <i class="icon icon-log"></i>
      <span class="title">{{getDict(67)}}</span>
      <!-- <div class="select">
        <span class="text">123</span>
        <i class="down-icon"></i>
      </div> -->
    </div>
    <div class="list-box" v-if="gambleList.length != 0">
      <div class="item" v-for="(item,index) in gambleList" :key="index">
        <div class="title">{{item.guess.name}}</div>
        <div class="info">
          <span class="time">{{item.guess_bet_info.ts | formatDate('YYYY-MM-DD')}}</span>
          <span class="select">{{getDict(69) | formatDict(item.guess.options[item.guess_bet_info.choice].content)}}</span>
        </div>
        <div class="money">
          <span v-if="item.guess.right_choice == -1">0</span>
          <template v-else>
            <span class="win" v-if="item.guess.right_choice == item.guess_bet_info.choice">+{{item.guess_bet_info.won_money}}</span>
            <span class="lose" v-if="item.guess.right_choice != item.guess_bet_info.choice">-{{item.guess_bet_info.money}}</span>
          </template>
        </div>
        <div class="name">
          <i class="icon icon-streamer"></i>
          <span>{{item.guess.streamer}}</span>
        </div>
      </div>
      <div class="item no-show" v-for="i in (gambleList.length%2?(2 - gambleList.length%2):0)" :key="'i'+i"></div>

      <div class="list-bottom-ctrl" v-if="gambleList.length >= pageInfp.limit">
        <span class="more" @click="getGamble" v-if="showMore">
          <i class="icon icon-plus"></i>
          <span>{{getDict(68)}}</span>
        </span>
        <span class="no-more" v-else>
          <i class="icon icon-no-gamble"></i>
          <span>{{getDict(88)}}</span>
        </span>
      </div>
    </div>

    <div class="no-follow" v-if="gambleList.length == 0">
      <div class="img">
        <i class="icon icon-no-gamble"></i>
      </div>
      <div class="tips">
        <span>{{getDict(87)}}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin, webSocket } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'
  import ScrollBox from '../../components/scrollBox'

  export default {
    mixins:[],
    props:{
    },
    data(){
      return {
        loading:true,
        gambleList:[
          // {
          //   guess: { //竞猜信息
          //     end_ts: 10,
          //     guess_id: "gu_r0_1558939911780640400",
          //     name: "哪支战队能获胜",
          //     options: [
          //       {
          //         content: "skt",
          //         odds: 10
          //       },
          //       {
          //         content: "ig",
          //         count: 1,
          //         odds: 10
          //       },
          //       {
          //         content: "ssw",
          //         odds: 10
          //       }
          //     ],
          //     right_choice: -1,
          //     room_id: "r0",
          //     ts: 1558939911780
          //   },
          //   guess_bet_info: { //竞猜投注信息
          //     choice: 1,
          //     guess_id: "gu_r0_1558939911780640400",
          //     guess_bet_id: "go_1558940973659181900_u0",
          //     money: 10,
          //     odds: 1,
          //     ts: 1558940973659,
          //     uid: "u0"
          //   }
          // }


        ],
        pageInfp:{
          limit:10,
          next:0,
        },
        showMore:true,
      }
    },
    computed:{
      ...mapState(['userData']),
    },
    watch:{
      'userData.userName'(){
        this.getGamble();
      }
    },
    methods: {
      getDict,
      async getGamble(){
        if(!this.userData.userName){
          return;
        }
        let data = await webSocket.get('/live/guess/bet/find',{
          limit: this.pageInfp.limit,
          cursor: this.pageInfp.next,
        });
        this.pageInfp.next = data.next_cursor
        if(data.results && data.results.length){
          this.gambleList = this.gambleList.concat(data.results);
          this.pageInfp.next = data.next_cursor;
          if(data.results.length < this.pageInfp.limit){
            this.showMore = false;
          }
        }else{
          this.showMore = false;
        }
        this.loading = false;
        
      },
    },
    components: {
      alert,ScrollBox,
    },
    mounted(){
      
    },
    created(){
      this.getGamble()
    }
  }
</script>

<style lang="scss" scoped>
  .sub-container{
    width: 100%;
    height: 100%;
    padding: 0.4rem;
    display: flex;
    flex-direction: column;

    .top-ctrl{
      $font-size: 0.2rem;
      color: #ffc650;
      display: flex;
      align-items: center;
      height: 0.6rem;
      font-size: $font-size;
      .select{
        margin-left: 0.1rem;
        display: inline-flex;
        align-items: center;
        // display: inline-block;
        background-color: #32373c;
        line-height: $font-size *1.6;
        border:1px solid #ffc650;
        border-radius:0.05rem;
        width: 1rem;

        .text{
          display: inline-block;
          flex:1;
          text-align: center;
        }
        .down-icon{
          margin:0 0.1rem;
          vertical-align: middle;
          display: inline-block;
          $size:0.15rem;
          // width: $size;
          // height: $size * 0.8;
          border: #{$size/2} solid;
          border-bottom: 0;
          border-top: #{$size *0.6} solid;
          border-right-color: rgba(0,0,0,0);
          border-left-color: rgba(0,0,0,0);
        }
      }
    }

    .list-box{
      height: 100%;
      overflow: scroll;
      flex-shrink: 1;
      display: flex;
      flex-flow: wrap;
      justify-content: space-between;
      align-items: flex-start;

      .item{
        $width: 4.3rem;
        $padding: 0.15rem;
        /* margin-top: 0.2rem;
        &:nth-child(-n + 2){
          margin-top: 0;
        }  */
        // margin-left: 0.2rem;
        // &:nth-child(2n +1){
        //   margin-left: 0;
        // }

        margin-bottom: 0.2rem;
        &:nth-last-child(-n + 3){
           margin-bottom: 0;
        }

        &.no-show{
          height: 0;
          padding: 0;
        }

        border-radius: 0.1rem;

        width: $width;
        height: $width * 2/5;

        background-image: url(./imgs/follow-video-bg.png);
        background-repeat: no-repeat;
        background-position: right;
        background-size: auto 100% ; 
        background-color: #fff;
        padding: #{$padding} 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        color: #46494e;

        .title{
          padding: 0 #{$padding};
          font-size: 0.24rem;
          font-weight: 600;
        }
        .info{
          padding: 0 #{$padding};
          font-size: 0.2rem;
          .select{
            color: #dc7c00;
            font-weight: 600;
          }
        }
        .money{
          padding: 0 #{$padding};
          text-align: center;
          background-color: rgba(100,100,100,0.1);
          font-size: 0.3rem;
          font-weight: 600;
          .win{
            color: #dc7d00;
          }
          .lose{
            color: #57ad48;
          }
        }
        .name{
          padding: 0 #{$padding};
          font-size: 0.2rem;
          .icon{
            // overflow: hidden;

            vertical-align: text-bottom;
          }
        }
        
      }
      .subscription-info{}
    }

    .list-bottom-ctrl{
      $font-size: 0.2rem;
      margin-top: 0.1rem;
      padding: 0.1rem 0;
      font-size: $font-size;
      width: 100%;
      text-align:center;
      $box-hight:$font-size *2;

      .no-more{
        display: inline-block;
        height: $box-hight;
        line-height: $box-hight;
        .icon{
          width: $font-size *1.5;
          height: $font-size *1.5;
          vertical-align: middle;
        }
      }
      .more{
        display: inline-block;
        height: $box-hight;
        width: 2.4rem;
        line-height: $box-hight;
        background-color: #555;
        border-radius: 0.07rem;
        .icon{
          vertical-align: middle;
        }
      }
    }

    .no-follow{
      text-align: center;
      display: flex;
      flex-direction: column;
      height: 90%;
      justify-content: center;
      .img{
        .icon{
          margin: 0;
        }
      }
      .tips{
        margin-top: 0.1rem;
        font-size: 0.25rem;
      }
    }
  }




</style>
